import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]", {});

document.querySelectorAll('.open-greed-img').forEach(button => {
    button.addEventListener('click', function(e) {
        e.preventDefault();

        const targetSelector = this.dataset.target;
        const currentCanvas = document.querySelector(targetSelector);

        // Скрыть все сетки
        document.querySelectorAll('.canvas-text.active').forEach(el => {
            const siblingCanvas = el.parentElement.querySelector('canvas');
            if (siblingCanvas) siblingCanvas.classList.remove('active');
        });

        document.querySelectorAll('.show-text').forEach(el => el.classList.remove('d-none'));
        document.querySelectorAll('.hide-text').forEach(el => el.classList.add('d-none'));

        // Если кликнута на текущую — просто переключаем
        if (currentCanvas && currentCanvas.classList.contains('active')) {
            currentCanvas.classList.remove('active');
            this.querySelector('.show-text')?.classList.remove('d-none');
            this.querySelector('.hide-text')?.classList.add('d-none');
        } else if (currentCanvas) {
            currentCanvas.classList.add('active');
            this.querySelector('.show-text')?.classList.add('d-none');
            this.querySelector('.hide-text')?.classList.remove('d-none');
        }
    });
});

document.querySelectorAll('.open-greed-img').forEach(button => {
    const targetSelector = button.dataset.target;

    button.addEventListener('mouseenter', function() {
        const siblingCanvas = this.parentElement.querySelector(targetSelector);
        if (siblingCanvas) siblingCanvas.classList.add('active_hover');
    });

    button.addEventListener('mouseleave', function() {
        const siblingCanvas = this.parentElement.querySelector(targetSelector);
        if (siblingCanvas) siblingCanvas.classList.remove('active_hover');
    });
});

document.querySelectorAll('.open-product-content').forEach(button => {
    button.addEventListener('click', function(e) {
        e.preventDefault();

        document.querySelectorAll('.content-product').forEach(el => {
            el.classList.toggle('d-none');
        });
    });
});